export function emitEvent(host: EventTarget, name: string, detail: unknown): void {
    host.dispatchEvent(new CustomEvent(name, { detail, bubbles: true, composed: true }));
}

export function emitWarning(host: EventTarget, name: string, data: object): void {
    const detail = { name: name.toLowerCase(), data };
    host.dispatchEvent(new CustomEvent('der.warning', { detail, bubbles: true, composed: true }));
}

export function emitError(host: EventTarget, name: string, data: object): void {
    const detail = { name: name.toLowerCase(), data };
    host.dispatchEvent(new CustomEvent('der.error', { detail, bubbles: true, composed: true }));
}
